var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD740",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z",
    transform: "translate(-985 -444) translate(985 444)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 10c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8z",
    transform: "translate(-985 -444) translate(985 444)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD740"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-1.797 3.172c0-.552.546-1 .901-1h4.952c.357 0 .484.444.484 1 0 .553-.556 1.047-.911 1.047l-4.525-.047c-.357 0-.901-.444-.901-1z",
    transform: "translate(-985 -444) translate(985 444) translate(5 2) scale(1 -1) rotate(60 15.46 1.165) rotate(90 1.371 3.196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.32 7.02c0-.551.15-.932.587-.932l6.126-.214c.44 0 1.062.444 1.062 1 0 .553-.624 1-1.062 1l-6.126.214c-.44 0-.588-.511-.588-1.067z",
    transform: "translate(-985 -444) translate(985 444) translate(5 2) scale(1 -1) rotate(60 15.46 1.165) rotate(32 4.207 6.98)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.8831d736e179a8dbe4f3810b99621c90.svg";
export { ForwardRef as ReactComponent };